import { Toast } from "../ds/index.js";
import { useStudio } from "../lib/studioContext.js";

export default function Toaster() {
  const { toast, dismissToast } = useStudio();
  if (!toast) return null;

  return (
    <div style={{ position: "fixed", right: 24, bottom: 24, zIndex: 90, animation: "trybRise var(--dur-slow) var(--ease-spring)" }}>
      <Toast title={toast.title} description={toast.description} tone="success" onClose={dismissToast} />
    </div>
  );
}
